module.exports = __webpack_public_path__ + "img/finance_verification.2ce23243.svg";